import React, { useImperativeHandle, forwardRef, useRef } from 'react';

import { DialogoConfirmacao } from '../../../../Components';
import { api } from '../../../../services';

const FormDialog = forwardRef(({ handleClose }, ref) => {
  const refDialogoConfirmacao = useRef(null);

  useImperativeHandle(ref, () => ({
    handleOpen(id) {
      if (refDialogoConfirmacao.current) {
        refDialogoConfirmacao.current.handleOpen(
          'Deletar Cotação',
          'Tem certeza de que deseja deletar esta cotação',
          id,
        );
      }
    },
  }));

  async function handleConfirma(id) {
    await api.delete(`/cotacoes/${id}`);
    handleClose();
  }

  return (
    <DialogoConfirmacao
      ref={refDialogoConfirmacao}
      handleConfirma={handleConfirma}
    />
  );
});

export default FormDialog;
